module.exports = "<h1> \r\n      Visualização de Pedidos\r\n</h1>      \r\n    \r\n  \r\n"